import React, {Fragment, useEffect, useState} from 'react';
import {Container, Button, Modal} from "react-bootstrap";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import {Pencil, Trash} from "react-bootstrap-icons";
import licensePlateActions from "../../../actions/licensePlateActions";

import LicensePlateForm from "./form";

const LicensePlates = (props) => {

  const [showModal, setShowModal] = useState(false);
  const [selectedLicensePlate, setSelectedLicensePlate] = useState({});
  const {licensePlates} = props.licensePlate;

  useEffect(() => {
    props.licensePlateActions.getList();
  }, []);

  const columns = [
    {
      dataField: 'id',
      text: 'id'
    },
    {
      dataField: 'licensePlate',
      text: 'Kenteken',
      filter: textFilter()
    },
    {
      dataField: 'defaultWeighing',
      text: 'Standaard Gewicht',
      filter: textFilter()
    },
    {
      dataField: 'id',
      formatter: (cell, row) => {
        return <Button size="sm" variant="secondary" onClick={() => { setSelectedLicensePlate(row); setShowModal(true); }}><Pencil /></Button>
      }
    },
    {
      dataField: 'id',
      formatter: (cell, row) => {
        return <Button size="sm" variant="danger" onClick={() => {
          if (window.confirm('Weet je het zeker?')) {
            props.licensePlateActions.deleteLicensePlate(row.id).then(() => props.licensePlateActions.getList());
          }
        }}><Trash/></Button>
      }
    }
  ];

  const handleSubmit = (values) => {
    let newData = {...values};


    if(values.id) {
      delete newData.id;
      props.licensePlateActions.patchLicensePlate(values.id, newData).then(() => {
        setShowModal(false);
        props.licensePlateActions.getList();
      });
    } else {
      props.licensePlateActions.postLicensePlate(newData).then(() => {
        setShowModal(false);
        props.licensePlateActions.getList();
      });
    }
  };

  return (
    <Container fluid>
      <h2>Kentekens</h2>

      <Button
        variant="success"
        onClick={() => {
          setSelectedLicensePlate(props.licensePlate.emptyLicensePlate);
          setShowModal(true);
        }}
      >
        Nieuw
      </Button> <br /><br />

      <BootstrapTable
        keyField='id'
        data={licensePlates}
        columns={columns}
        filter={filterFactory()}
        bootstrap4={true}
      />

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Kenteken formulier
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LicensePlateForm
            handleSubmit={handleSubmit}
            data={selectedLicensePlate}
          />
        </Modal.Body>
      </Modal>
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    licensePlate: state.licensePlate
  }
};

const mapDispatchToProps = dispatch => {
  return {
    licensePlateActions: bindActionCreators(licensePlateActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LicensePlates);
